export default __webpack_public_path__ + "static/media/AutoAdvance_159x150.45971017.png";